<template>
    <form
        ref="form"
        data-url="/admin/auth/users"
        class="mb-sm-0"
        :class="{ 'loading-opacity': preloader }">
        <div class="row">
            <div class="col-md-6">
                <label for="text_input">
                    {{ $t("first_name") }}
                </label>
                <app-input
                    id="name"
                    type="text"
                    :required="true"
                    v-model="inputs.first_name"
                />
            </div>
            <div class="col-md-6">
                <label for="text_input">
                    {{ $t("last_name") }}
                </label>
                <app-input
                    id="name"
                    type="text"
                    :required="true"
                    v-model="inputs.last_name"
                />
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12">
                <label for="text_input">
                    {{ $t("email") }}
                </label>
                <app-input
                    id="email"
                    type="email"
                    :required="true"
                    v-model="inputs.email"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label for="text_input">
                    {{ $t("phone") }}
                </label>
                <app-input
                    id="phone"
                    type="tel-input"
                    :required="true"
                    :placeholder="$t('type_contact_number')"
                    v-model="inputs.phone"
                />
            </div>
            <div class="col-md-6">
                <label for="text_input">
                    {{ $t("role") }}
                </label>
                <app-input
                    id="roles"
                    type="multi-select"
                    :list="roleLists"
                    list-value-field="name"
                    :isAnimatedDropdown="true"
                    v-model="inputs.roles"
                    :required="true"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label for="text_input">
                    {{ $t("password") }}
                </label>
                <app-input
                    type="password"
                    :required="true"
                    :specialValidation="true"
                    v-model="inputs.password"
                />
                </div>
            <div class="col-md-6">
                <label for="text_input">
                    {{ $t("confirm_password") }}
                </label>
                <app-input
                    type="password"
                    v-model="inputs.confirm_password"
                    same-as="inputs_password"
                />
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-12">
            <app-note
                note-type="note-warning"
                :show-title="false"
                :notes="[$t('password_hint_note')]"
            />
            </div>
        </div>
        <div class="row mt-2 text-right">
            <div class="col-md-12">
                <button class="btn btn-primary" @click.prevent="saveUser()">Save</button>
                <button class="btn btn-dark" @click.prevent="backTaskCreate()">Back</button>
            </div>
        </div>
    </form>
</template>


<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { axiosPost, axiosGet } from "../../../../Helpers/AxiosHelper";
import { ROLES, INTERNAL_USERS, SITE_USER_ASSIGNED, GET_SITE_USER_ASSIGNED_LIST, DELETE_SITE_ASSIGNED_USER } from "../../../../Config/ApiUrl";

export default {
  name: "ShortCutUserCreate",
  mixins: [FormMixin],
  props: {
    back: Function,
  },
  data() {
    return {
      preloader: false,
      users: null,
      inputs: {},
      roleLists: [],
      modalId: "demo-assign-user-Modal",
      modalTitle: this.$t("assign_user"),
    }
  },
  methods: {
      backTaskCreate() {
        this.back(1);
    },
    getRoles() {
      this.axiosGet(ROLES)
        .then((response) => {
          this.roleLists = response.data.data;
        })
        .catch(({ response }) => {})
    },
    saveUser() {
        this.inputs.company_id = this.userRole.company_id;
        this.save(this.inputs);
    },
    afterSuccess(response) {
        this.$toastr.s(response.data.message);
        this.back(1);
    },
  },
  mounted() {
      this.getRoles();
  },
  computed: {
     userRole() {
      return this.$store.state.user.loggedInUser;
    },
  }
};
</script>
